import React, { useRef } from 'react';
import styles from './styles.module.scss';
import bgBanner from 'assets/img/bg_staking_banner.png';
import TabList from './Components/TabList';
import StakingDashboard from './Components/StakingDashboard';
import { RouteName } from 'src/routes/config';
import { useLocation } from 'react-router';
import YourStakingDetail from './Components/YourStakingDetail';
import useIntersectionObserver from 'src/hooks/useIntersectionObserver';
import classNames from 'classnames';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { getEstimateApr, getStakingConfig, getStakingStats } from 'src/redux/actions';
import PopupProvider from './PopupProvider';
import StakingBanner from './Components/StakingBanner';

const Staking = () => {
  const dispatch = useTypedDispatch();
  const [showStakingBanner, setShowStakingBanner] = React.useState(true);
  const {
    pathname
  } = useLocation();
  const stakingConfig = useTypedSelector(state => state.stakingConfig.data);
  const refTitle = useRef(null);
  const entry = useIntersectionObserver(refTitle, {});
  const isVisible = entry === null || entry === void 0 ? void 0 : entry.isIntersecting;
  React.useEffect(() => {
    dispatch(getStakingStats());
    dispatch(getStakingConfig());
    dispatch(getEstimateApr());
  }, []);

  const renderContent = () => /*#__PURE__*/React.createElement(React.Fragment, null, pathname === RouteName.Staking && /*#__PURE__*/React.createElement(StakingDashboard, null), pathname === RouteName.YourStaking && /*#__PURE__*/React.createElement(YourStakingDetail, null));

  const isShowStakingBanner = React.useMemo(() => {
    const now = Date.now();
    return showStakingBanner && (stakingConfig === null || stakingConfig === void 0 ? void 0 : stakingConfig.promotion) && stakingConfig.promotion.end && stakingConfig.promotion.end >= now && stakingConfig.promotion.begin && stakingConfig.promotion.begin <= now;
  }, [showStakingBanner, stakingConfig]);

  const onFinishCountdown = () => {
    setShowStakingBanner(false);
  };

  return /*#__PURE__*/React.createElement(PopupProvider, null, /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.wrapStakingBanner
  }, (stakingConfig === null || stakingConfig === void 0 ? void 0 : stakingConfig.promotion) && isShowStakingBanner && /*#__PURE__*/React.createElement(StakingBanner, {
    onFinished: onFinishCountdown,
    promotion: stakingConfig.promotion
  })), /*#__PURE__*/React.createElement("img", {
    className: classNames(styles.banner, isShowStakingBanner && styles.top),
    src: bgBanner
  }), /*#__PURE__*/React.createElement("div", {
    ref: refTitle,
    className: styles.title
  }, /*#__PURE__*/React.createElement("span", null, pathname === RouteName.Staking ? 'THG Staking Dashboard' : 'My Staking')), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.tabContainer, !isVisible ? styles.showBackground : null)
  }, /*#__PURE__*/React.createElement(TabList, {
    className: styles.tab
  })), renderContent()));
};

export default Staking;